import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../Landing/Navbar";
import Select, { StylesConfig } from "react-select";
import { CSSProperties, useEffect, useState } from "react";
import countries from "../../data/countries.json";
import { useForm } from "react-hook-form";
import FormRequired from "../Shared/FormRequired";
import APIService from "../../services/Api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Notify from "../../toast/Notify";
import { CgSpinner } from "react-icons/cg";
import { UseAuth } from "../../auth/AuthContext";
import { MyOptionType } from "../../types";
import Footer from "../Landing/Footer";
import { AES } from "crypto-js";
import { classNames } from "src/helpers/mixins";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

type IsMulti = false;
const customControlStyles: CSSProperties = {
  boxShadow: "none",
  color: "#113843",
  height: "50px",
  width: "100%",
};
type IRegister = {
  email: string;
  password1: string;
  password2: string;
  country: string;
  phone: string;
  terms: boolean;
};

type RegisterFormParams = {
  disableImage?: boolean;
  disabledBackground?: boolean;
  classTitle?: string;
  role?: string;
  cashierFather?: string;
};
const RegisterForm = ({
  disableImage,
  classTitle,
  disabledBackground,
  role,
  cashierFather,
}: RegisterFormParams) => {
  const { t } = useTranslation();
  const { setUserData } = UseAuth();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<IRegister>();
  //const [success, setSuccess] = useState<boolean>(false);
  const [inputType, setInputType] = useState<string>("password");
  //const [error, setError] = useState<boolean>(false);
  //const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    setValue("country", "CO");
  }, []);

  const handleRegister = async (data: IRegister) => {
    const finalPassword = AES.encrypt(
      data.password1,
      process.env.REACT_APP_SECRET_KEY || "SlllM3L$uN<>w32r"
    );
    if(data.phone.length <=3){
      Notify('Ingresa un número telefónico válido.', "warning");
    }else{
      if (data.password1.length >= 7) {
        //setLoading(true);
        const token = await APIService.getToken();
        localStorage.setItem("accessToken", token.data.data.accessToken);
        const register = await APIService.userRegister({
          email: data.email,
          password: finalPassword.toString(),
          country: getValues("country"),
          phone: data.phone,
          role: role ? role : "user",
          cashierFather,
        });
  
        if (register.data.status) {
          localStorage.setItem("authToken", register.data.data.authToken);
          if (cashierFather && role === "user") {
            const dataNotification = {
              message: `Te informamos que el cliente ${data.email} se ha registrado con éxito. Presiona leer más para visitar su perfil`,
              userId: cashierFather || "",
              type: "registerclient",
              typeId: register?.data?.data?.user?.id,
              link: `/usuario/${register?.data?.data?.user?.id}`,
            };
            await APIService.notificationCreate(dataNotification);
          }
  
          //setSuccess(true);
          Notify(register.data.message, "success");
  
          setUserData(
            register.data.data.user.id,
            data.email,
            data.email,
            data.phone,
            data.country,
            "",
            false,
            register.data.data.user.role,
            false,
            register.data.data.user.createdAt,
            register.data.data.user.photoUrl || "",
            register.data.data.user.nickname || '',
            register.data.data.user.lastConnection || ''
          );
          if (register.data.data.user.role === "cashier") {
            navigate(`/cashier/procesadores`);
          } else if (register.data.data.user.role === "user") {
            navigate(`/usuario/${register.data.data.user.id}`);
          }
        } else {
          Notify(register.data.message, "error");
          //setError(true);
        }
        //setLoading(false);
      } else {
        Notify('La contraseña debe tener al menos 7 caracteres.', "warning");
      }
    }
  };
  const options = countries.map((country) => ({
    value: country.code,
    label: country.name + " " + country.dial_code,
  }));

  const handleSelect = (e: any) => {
    setValue("country", e);
  };
  const selectStyle: StylesConfig<MyOptionType, IsMulti> = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "#FFF",
      color: state.isSelected ? "#2d7b5c" : "#113843",
      "&:hover": {
        backgroundColor: "#e7e5e4",
      },
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#FFF",
      borderColor: state.isFocused ? "#2d7b5c" : "#D1D5DB",
      borderRadius: "5px",
      background: "#fff",
      boxShadow: state.isFocused ? "#2d7b5c" : "#D1D5DB",
      "&:hover": {
        borderColor: state.isFocused ? "#2d7b5c" : "#D1D5DB",
        boxShadow: "none",
      },
      height: "50px",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#113843",
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: 0,
    }),
    container: (provided, state) => {
      return {
        ...provided,
        ...customControlStyles,
      };
    },
  };
  return (
    <section>
      <ToastContainer
        position="bottom-center"
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="grid lg:grid-cols-3 grid-cols-1  gap-0 flex flex-wrap">
        {!disableImage && (
          <div className="bg-register col-span-1 hidden lg:block"></div>
        )}

        <div
          className={classNames("", disableImage ? "col-span-3" : "col-span-2")}
        >
          <section
            className={classNames(
              disabledBackground ? "" : "body-register-container",
              " px-2 md:px-6"
            )}
          >
            <div
              className={classNames(
                classTitle ? ` ${classTitle} ` : "text-white",
                "lg:mt-1 text-2xl lg:text-2xl font-bold opensans px-2 pt-1 lg:pt-10 underline pt-10"
              )}
            >
              {t("register")}
            </div>
            <form
              name="formRegisterisf"
              onSubmit={handleSubmit(handleRegister)}
              action="#"
              className="sm:mt-0 mt-1 w-full md:11/12 px-4 mx-auto md:mx-0 mb-10 grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-2 lg:gap-y-4 "
            >
              {/*<div className="flex flex-col  mt-6 ">
                <label htmlFor="" className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit">
                {t('fullname')}
                 </label>
                <input type="text" className="px-4 border border-stone-300 w-full h-10 rounded-md py-6 font-semibold bg-white" />
              </div>*/}
              <div className="flex flex-col mt-6">
                <label
                  htmlFor=""
                  className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit"
                >
                  {t("email")}
                </label>
                <input
                  {...register("email", { required: true, maxLength: 50 })}
                  type="email"
                  className="px-4 border border-stone-300 w-full h-10 rounded-md py-6 font-semibold bg-white"
                  maxLength={115}
                />
                {errors.email && (
                  <div className="bg-white mt-1 w-fit rounded-md px-2 py-1">
                    {" "}
                    <FormRequired />
                  </div>
                )}
              </div>
              <div className="flex flex-col mt-6">
                <label
                  htmlFor=""
                  className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit"
                >
                  {t("password")}
                </label>
                <div className="flex items-center gap-2">
                  <input
                    {...register("password1", {
                      required: true,
                      maxLength: 50,
                    })}
                    type={inputType || "password"}
                    className="px-4 border border-stone-300 w-full h-10 rounded-md py-6 font-semibold bg-white"
                  />
                  {inputType !== "password" ? (
                    <FaRegEye
                      className="text-black mr-10 cursor-pointer"
                      size={33}
                      onClick={() => setInputType("password")}
                    />
                  ) : (
                    <FaRegEyeSlash
                      className="text-black mr-10 cursor-pointer"
                      size={33}
                      onClick={() => setInputType("text")}
                    />
                  )}
                </div>
                {errors.password1 && (
                  <div className="bg-white mt-1 w-fit rounded-md px-2 py-1">
                    <FormRequired />
                  </div>
                )}
              </div>
              {/*               <div className="flex flex-col">
                <div className="flex flex-wrap justify-between ">
                  <label
                    htmlFor=""
                    className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit"
                  >
                    {t("confirmpassword")}
                  </label>
                </div>
                <input
                  {...register("password2", { required: true, maxLength: 50 })}
                  type="password"
                  className="px-4 border border-stone-300 w-full h-10 rounded-md py-6 font-semibold bg-white"
                />
                {errors.password2 &&
                  <div className="bg-white mt-1 w-fit rounded-md px-2 py-1">
                    <FormRequired />
                  </div>
                } 
              </div> */}
              <div className="flex flex-col ">
                <div className="flex flex-wrap justify-between ">
                  <label
                    htmlFor=""
                    className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit"
                  >
                    {t("countryphonecode")}
                  </label>
                </div>
                <Select
                  isSearchable={true}
                  options={options}
                  styles={selectStyle}
                  defaultValue={{
                    value: "CO",
                    label: "Colombia +57",
                  }}
                  onChange={(e) => handleSelect(e?.value)}
                  placeholder={`${t("countryPlacerholder")}`}
                />
              </div>
              <div className="flex flex-col ">
                <div className="flex flex-wrap justify-between ">
                  <label
                    htmlFor=""
                    className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit"
                  >
                    {t("phonewhatsapp")}
                  </label>
                </div>
                <input
                  type="tel"
                  {...register("phone", { required: true, maxLength: 50 })}
                  className="px-4 border border-stone-300 w-full h-10 rounded-md py-6 font-semibold bg-white"
                />
                {errors.phone && (
                  <div className="bg-white mt-1 w-fit rounded-md px-2 py-1">
                    {" "}
                    <FormRequired />{" "}
                  </div>
                )}
              </div>
              <div className="flex flex-col ">
                <div className="flex flex-wrap justify-between ">
                  <label
                    htmlFor="termscondition"
                    className="text-gray-dark text-sm font-bold opensans fadeinbottom  lg:font-bold text-center w-full lg:text-left bg-white rounded-md mb-2 px-2 w-fit"
                  >
                    {t("termsandconditions")}
                  </label>
                </div>
                <div className="flex items-center justify-start gap-x-2">
                  <input
                    id="termscondition"
                    type="checkbox"
                    {...register("terms", { required: true })}
                    className="px-4 border border-gray  w-6 h-6 rounded-md py-6"
                  />
                  <label
                    htmlFor="termscondition"
                    className="text-sm bg-white px-2 py-1 rounded-md opensans font-semibold"
                  >
                    {t("termsandconditionsaccept")}
                  </label>
                </div>
                {errors.terms && (
                  <div className="bg-white mt-1 w-fit rounded-md px-2 py-1">
                    <FormRequired />
                  </div>
                )}
              </div>
              <div className="flex w-full flex-col">
                <div className="justify-center text-sm w-full flex flex-wrap  ">
                  {!isSubmitting ? (
                    <button
                      type="submit"
                      className="px-3 md:px-0 w-full bg-green-admin-light hover:bg-black hite text-white  text-center rounded-md py-2 w-fit-content lg:m-1/2 text-lg font-bold opensans flex justify-center "
                    >
                      {t("continue")}
                    </button>
                  ) : (
                    <button
                      type="button"
                      disabled
                      className="px-3 md:px-0 w-full bg-green-admin-light hover:bg-black hite text-white  text-center rounded-md py-2 w-fit-content lg:m-1/2 text-lg flex justify-center h-12 items-center"
                    >
                      <div className="loader-dots"></div>
                    </button>
                  )}
                </div>
              </div>
              <div className="flex w-full flex-col items-center justify">
                <Link
                  to="/terminos-y-condiciones"
                  target="_blank"
                  className="justify-center text-sm bg-white text-black underline py-2 px-2 rounded-md items-center w-full font-bold md:font-medium flex flex-wrap  "
                >
                  {t("readterms")}
                </Link>
              </div>
            </form>

            {/*<div className="justify-end mt-4 mb-4 text-center gap-2 items-center flex flex-wrap  ">
              <h2 className="text-gray-d mb-0 text-lg font-bold">{t("alreadyaccount")}</h2>
              <Link to="/">
                <div className="text-dark-green text-lg underline font-bold cursor-pointer text-center hover:text-gray-dark">
                  {t("login")}
                </div>
              </Link>
            </div>*/}
          </section>
        </div>
      </div>
    </section>
  );
};

export default RegisterForm;
